import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const LEASING_INTEREST_REMOVED = gql`
  subscription leasingInterestRemoved {
    leasingInterestRemoved {
      interestTypeId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
